<template>
  <div class="semiconductor-pn-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>I = I₀(e^(qV/kT) - 1)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="220" viewBox="0 0 400 220">
          <!-- P-region and N-region -->
          <rect x="50" y="50" width="150" height="120" fill="rgba(255, 71, 87, 0.1)" stroke="#ff4757" />
          <rect x="200" y="50" width="150" height="120" fill="rgba(46, 213, 115, 0.1)" stroke="#2ed573" />
          <text x="100" y="40" fill="#ff4757" font-size="12">P 型 (空穴多)</text>
          <text x="250" y="40" fill="#2ed573" font-size="12">N 型 (电子多)</text>

          <!-- Depletion Layer -->
          <rect :x="200 - depletionWidth/2" y="50" :width="depletionWidth" height="120" fill="rgba(255, 255, 255, 0.05)" />
          <text :x="200" y="185" text-anchor="middle" fill="#888" font-size="10">耗尽层 (内建电场)</text>

          <!-- Carriers: Holes (P) and Electrons (N) -->
          <g v-for="n in 8" :key="'h'+n">
            <circle :cx="80 + (n%3)*30" :cy="70 + Math.floor(n/3)*30" r="4" fill="none" stroke="#ff4757" />
          </g>
          <g v-for="n in 8" :key="'e'+n">
            <circle :cx="260 + (n%3)*30" :cy="70 + Math.floor(n/3)*30" r="3" fill="#2ed573" />
          </g>

          <!-- Interaction: Carrier Movement -->
          <g v-if="bias === 'forward'">
             <path v-for="n in 3" :key="'f'+n" d="M 180, 80 L 220, 80" stroke="#ffd700" :transform="`translate(0, ${n*30})`" marker-end="url(#arrow)" />
             <text x="200" y="210" text-anchor="middle" fill="#ffd700" font-size="10">正向偏置：空穴与电子复合形成电流</text>
          </g>
          <g v-if="bias === 'reverse'">
             <path v-for="n in 2" :key="'r'+n" d="M 180, 90 L 150, 90" stroke="#888" :transform="`translate(0, ${n*40})`" marker-end="url(#arrow-rev)" />
             <text x="200" y="210" text-anchor="middle" fill="#888" font-size="10">反向偏置：耗尽层加宽，电流极小</text>
          </g>

          <defs>
            <marker id="arrow" markerWidth="8" markerHeight="6" refX="0" refY="3" orient="auto">
              <polygon points="0 0, 8 3, 0 6" fill="#ffd700" />
            </marker>
            <marker id="arrow-rev" markerWidth="8" markerHeight="6" refX="0" refY="3" orient="auto">
              <polygon points="0 0, 8 3, 0 6" fill="#888" />
            </marker>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>状态: {{ bias === 'forward' ? '正向导通' : (bias === 'reverse' ? '反向截止' : '零偏置') }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>施加电压</label>
             <el-radio-group v-model="bias" size="mini">
                <el-radio-button label="reverse">反向偏置 (-V)</el-radio-button>
                <el-radio-button label="zero">无电压 (0V)</el-radio-button>
                <el-radio-button label="forward">正向偏置 (+V)</el-radio-button>
             </el-radio-group>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>P-N结是现代电子学的基石。由于载流子的扩散，在交界面处形成**耗尽层**和**内建电场**。正向偏置削弱内建电场使电流易通过；反向偏置增强内建电场阻止电流。这就是二极管**单向导电性**的物理根源。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SemiconductorPNViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      bias: 'zero'
    }
  },
  computed: {
    depletionWidth() {
      if (this.bias === 'forward') return 10;
      if (this.bias === 'reverse') return 60;
      return 30;
    }
  }
}
</script>

<style scoped lang="scss">
.semiconductor-pn-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 10px; } 
}
.discovery-note { background: rgba(46, 213, 115, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
